import axios from 'axios';

const API_URL = '/api/upload';

export const uploadFile = async (file, category, userId) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('category', category);
    formData.append('userId', userId);

    try {
        const response = await axios.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
};

export const getFilesByUserId = async (user_id) => {
    try {
        const response = await axios.get(`${API_URL}/files/${user_id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching files:', error);
        throw error;
    }
}

export const deleteFile = async (fileId) => {
    try {
        const response = await axios.delete(`${API_URL}/${fileId}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting file:', error);
        throw error;
    }
}

